<template>
  <div class="account-card status-card" v-if="selected_order">
    <div class="account-header">
      <h4>{{ _T('Status') }}</h4>
    </div>
    <div class="account-body status-process">
      <ul class="row" v-if="order_system_status">
        <li class="col-lg-3 active">
          <div class="steps">
            <span>
              <svg
                width="23"
                height="27"
                viewBox="0 0 23 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.3573 15.2812V1.83537L15.6967 0.177583L13.9796 1.88306L12.4216 0.325027L11.0081 1.73854L9.39223 0.132812L7.65353 1.87152L5.95094 0.155938L4.13853 1.97704L2.36656 0.207997L0.585938 1.9756V22.1968L2.25094 23.8575L3.96796 22.1448L5.52599 23.6985L6.9395 22.285L8.5409 23.898L10.2796 22.155L11.1641 23.0395C11.0615 22.5799 11.0124 22.1087 11.0167 21.6375C11.0138 19.9537 11.6816 18.3378 12.871 17.1453C14.0605 15.9528 15.6735 15.2823 17.3573 15.2809L17.3573 15.2812ZM3.51711 6.58913H14.3829V7.88413H3.51711V6.58913ZM3.51711 9.74134H11.1021V11.0363L3.51711 11.0378V9.74279V9.74134ZM9.59621 14.1813L3.51711 14.1828V12.8878H11.1021V14.1828H9.5961L9.59621 14.1813Z"
                ></path>
                <path
                  d="M17.3603 16.3907C15.2443 16.3922 13.3365 17.6669 12.5273 19.6225C11.718 21.578 12.1646 23.8282 13.659 25.3256C15.1549 26.823 17.4053 27.2725 19.3607 26.466C21.3177 25.6595 22.5953 23.7531 22.5997 21.6371C22.604 20.2453 22.0533 18.9084 21.0691 17.9227C20.0848 16.9384 18.7494 16.3863 17.3561 16.3907L17.3603 16.3907ZM20.1801 20.3046L16.7576 23.7271C16.6521 23.8311 16.5119 23.889 16.3645 23.8904C16.2185 23.8904 16.0769 23.8326 15.9728 23.7271L15.8283 23.5826L14.5448 22.3035C14.3266 22.0867 14.3266 21.734 14.5434 21.5172C14.7587 21.299 15.1114 21.299 15.3296 21.5158L16.3659 22.5521L19.3967 19.5212H19.3953C19.4993 19.4157 19.6395 19.3565 19.787 19.3565C19.9344 19.3565 20.076 19.4157 20.1801 19.5212C20.394 19.738 20.394 20.0878 20.1801 20.3046L20.1801 20.3046Z"
                ></path>
              </svg>
            </span>
          </div>
          <div>
            <h6>{{ _T('Order Placed') }}</h6>
            <h4>
              {{
                convertDate(
                  orderStatusHistoryTime(
                    selected_order,
                    'ORDER_HISTORY_TYPE_RECORD_NEW'
                  )
                )
              }}
            </h4>
          </div>
        </li>
        <li class="col-lg-3 active">
          <div class="steps">
            <span>
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0)">
                  <path
                    d="M12.8696 0.847656L14.6272 3.17225L12.8574 5.5128C16.5537 5.69963 19.4931 8.75553 19.4931 12.4977C19.4931 13.6384 19.218 14.7134 18.7345 15.6654L19.878 18.3722L22.7715 18.0117C23.6541 16.3696 24.1554 14.4928 24.1554 12.4979C24.1563 6.18336 19.1363 1.0431 12.8695 0.847704L12.8696 0.847656Z"
                  ></path>
                  <path
                    d="M6.27307 15.6815C5.78392 14.7267 5.50603 13.6451 5.50603 12.4989C5.50603 8.76125 8.438 5.70911 12.1268 5.51467L13.8975 3.17318L12.14 0.847656C5.8684 1.03824 0.84375 6.18115 0.84375 12.4989C0.84375 14.4902 1.34415 16.365 2.22386 18.0052L3.35893 15.3191L6.27307 15.6815Z"
                  ></path>
                  <path
                    d="M18.3701 16.3016C17.1243 18.2224 14.9611 19.4945 12.5004 19.4945C10.0463 19.4945 7.88868 18.229 6.64009 16.3165L3.72398 15.9531L2.58984 18.6383C4.64592 21.9504 8.31486 24.1568 12.5002 24.1568C16.6817 24.1568 20.3489 21.9543 22.406 18.6467L19.5135 19.0072L18.3701 16.3016Z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect
                      x="0.482422"
                      y="0.484375"
                      width="24.0345"
                      height="24.0345"
                      fill="white"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </span>
          </div>
          <div
            v-if="selected_order.order_system_status === 'requires_acceptance'"
          >
            <h6>{{ _T(orderStatus(selected_order.order_status)) }}</h6>
            <h4>
              {{
                convertDate(
                  orderStatusHistoryTime(
                    selected_order,
                    'ORDER_HISTORY_TYPE_RECORD_REQUIRES_ACCEPTANCE'
                  )
                )
              }}
            </h4>
          </div>
          <div v-else>
            <h6>{{ _T('Order Canceled') }}</h6>
            <h4>
              {{
                convertDate(
                  orderStatusHistoryTime(
                    selected_order,
                    'ORDER_HISTORY_TYPE_RECORD_CANCELLED'
                  )
                )
              }}
            </h4>
          </div>
        </li>
      </ul>
      <ul class="row" v-else>
        <li class="col-lg-3 active">
          <div class="steps">
            <div class="steps-line"></div>
            <span>
              <svg
                width="23"
                height="27"
                viewBox="0 0 23 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.3573 15.2812V1.83537L15.6967 0.177583L13.9796 1.88306L12.4216 0.325027L11.0081 1.73854L9.39223 0.132812L7.65353 1.87152L5.95094 0.155938L4.13853 1.97704L2.36656 0.207997L0.585938 1.9756V22.1968L2.25094 23.8575L3.96796 22.1448L5.52599 23.6985L6.9395 22.285L8.5409 23.898L10.2796 22.155L11.1641 23.0395C11.0615 22.5799 11.0124 22.1087 11.0167 21.6375C11.0138 19.9537 11.6816 18.3378 12.871 17.1453C14.0605 15.9528 15.6735 15.2823 17.3573 15.2809L17.3573 15.2812ZM3.51711 6.58913H14.3829V7.88413H3.51711V6.58913ZM3.51711 9.74134H11.1021V11.0363L3.51711 11.0378V9.74279V9.74134ZM9.59621 14.1813L3.51711 14.1828V12.8878H11.1021V14.1828H9.5961L9.59621 14.1813Z"
                ></path>
                <path
                  d="M17.3603 16.3907C15.2443 16.3922 13.3365 17.6669 12.5273 19.6225C11.718 21.578 12.1646 23.8282 13.659 25.3256C15.1549 26.823 17.4053 27.2725 19.3607 26.466C21.3177 25.6595 22.5953 23.7531 22.5997 21.6371C22.604 20.2453 22.0533 18.9084 21.0691 17.9227C20.0848 16.9384 18.7494 16.3863 17.3561 16.3907L17.3603 16.3907ZM20.1801 20.3046L16.7576 23.7271C16.6521 23.8311 16.5119 23.889 16.3645 23.8904C16.2185 23.8904 16.0769 23.8326 15.9728 23.7271L15.8283 23.5826L14.5448 22.3035C14.3266 22.0867 14.3266 21.734 14.5434 21.5172C14.7587 21.299 15.1114 21.299 15.3296 21.5158L16.3659 22.5521L19.3967 19.5212H19.3953C19.4993 19.4157 19.6395 19.3565 19.787 19.3565C19.9344 19.3565 20.076 19.4157 20.1801 19.5212C20.394 19.738 20.394 20.0878 20.1801 20.3046L20.1801 20.3046Z"
                ></path>
              </svg>
            </span>
          </div>
          <div>
            <h6>{{ _T(CONST.IN_PROGRESS) }}</h6>
            <h4 v-if="selected_order">
              {{
                convertDate(
                  orderStatusHistoryTime(
                    selected_order,
                    'ORDER_HISTORY_TYPE_RECORD_SENT_TO_KITCHEN'
                  )
                )
              }}
            </h4>
          </div>
        </li>
        <li class="col-lg-3" :class="{ active: active_status > 1 }">
          <!-- <div class="steps-line"></div> -->
          <div class="steps">
            <span>
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0)">
                  <path
                    d="M12.8696 0.847656L14.6272 3.17225L12.8574 5.5128C16.5537 5.69963 19.4931 8.75553 19.4931 12.4977C19.4931 13.6384 19.218 14.7134 18.7345 15.6654L19.878 18.3722L22.7715 18.0117C23.6541 16.3696 24.1554 14.4928 24.1554 12.4979C24.1563 6.18336 19.1363 1.0431 12.8695 0.847704L12.8696 0.847656Z"
                  ></path>
                  <path
                    d="M6.27307 15.6815C5.78392 14.7267 5.50603 13.6451 5.50603 12.4989C5.50603 8.76125 8.438 5.70911 12.1268 5.51467L13.8975 3.17318L12.14 0.847656C5.8684 1.03824 0.84375 6.18115 0.84375 12.4989C0.84375 14.4902 1.34415 16.365 2.22386 18.0052L3.35893 15.3191L6.27307 15.6815Z"
                  ></path>
                  <path
                    d="M18.3701 16.3016C17.1243 18.2224 14.9611 19.4945 12.5004 19.4945C10.0463 19.4945 7.88868 18.229 6.64009 16.3165L3.72398 15.9531L2.58984 18.6383C4.64592 21.9504 8.31486 24.1568 12.5002 24.1568C16.6817 24.1568 20.3489 21.9543 22.406 18.6467L19.5135 19.0072L18.3701 16.3016Z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect
                      x="0.482422"
                      y="0.484375"
                      width="24.0345"
                      height="24.0345"
                      fill="white"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </span>
          </div>
          <div>
            <h6>{{ _T(CONST.READY) }}</h6>
            <h4 v-if="active_status > 1">
              {{
                convertDate(
                  orderStatusHistoryTime(
                    selected_order,
                    'ORDER_HISTORY_TYPE_RECORD_READY'
                  )
                )
              }}
            </h4>
          </div>
        </li>
        <li class="col-lg-3" :class="{ active: active_status > 2 }">
          <!-- <div class="steps-line"></div> -->
          <div class="steps">
            <span>
              <svg
                width="59"
                height="59"
                viewBox="0 0 59 59"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M27.9146 24.8566C26.9367 24.4322 25.9239 24.6455 24.8805 24.7439C23.4805 24.8752 22.0969 25.0403 20.688 25.0447C19.603 25.0491 19.6337 26.6219 20.688 26.7061C21.9262 26.8056 23.1752 26.7466 24.4123 26.6438C25.564 26.5475 26.8492 26.6656 27.9146 26.2019C28.4242 25.9799 28.4264 25.0775 27.9146 24.8566Z"
                  fill="red"
                />
                <path
                  d="M41.1385 34.3383C40.8268 33.8046 40.0218 33.214 39.1829 32.9274C39.7582 32.8486 40.351 32.8497 40.946 32.9383C41.3081 32.9919 41.6395 32.6616 41.436 32.3007C40.7524 31.0866 39.2398 30.7344 37.9055 30.823C38.2533 29.4394 38.669 27.7626 38.0116 26.4755C37.6113 25.6923 37.0742 25.0711 36.3469 24.5592C35.5102 23.9697 33.9833 23.3779 33.4671 22.3706C33.4649 22.3433 33.4682 22.3148 33.4671 22.2875C34.3388 23.2095 36.1008 23.5267 36.7582 22.2229C37.4703 20.812 36.3032 19.6997 34.8267 19.9042C34.4679 19.9545 34.166 20.0541 33.8554 20.2367C33.6323 20.368 33.4573 20.5856 33.2878 20.7748C32.8306 21.2823 32.1984 21.4136 31.5356 21.4016C31.0303 21.3928 30.0229 21.5383 29.8326 22.1223C29.6904 22.5577 29.8403 23.2708 30.4265 23.2708C31.2195 23.2708 32.0212 22.4056 32.7704 22.0086C32.2881 24.9332 35.1428 27.0979 32.8087 29.876C31.7314 31.1579 30.0809 31.322 28.5214 31.4084C27.3259 31.4751 26.3754 30.9534 26.9486 29.7109C27.1279 29.3226 27.3664 28.9617 27.5523 28.5745C27.7328 28.1971 27.514 27.776 27.082 27.7564C24.9612 27.659 22.7845 27.6065 20.6694 27.8745C19.8611 27.9773 19.5057 29.024 19.1075 29.5982C18.0029 31.1842 17.4855 33.4569 19.7846 33.9088C19.475 34.4043 19.2749 34.9818 19.2169 35.5079C19.043 37.1047 20.3424 38.3395 21.8616 38.3899C23.4126 38.4413 24.6288 37.2251 24.7753 35.7398C24.7994 35.4882 24.7644 35.2388 24.6856 34.9982C26.5592 35.4871 28.7467 35.0453 30.6597 35.3351C32.0192 35.5407 33.1556 35.0649 34.2462 34.3693C34.2036 34.7095 34.1981 35.0518 34.2353 35.3865C34.2954 35.929 35.1048 35.9585 35.1037 35.3865C35.1037 35.334 35.1081 35.2848 35.1092 35.2334C35.4417 34.8232 35.8212 34.4612 36.2357 34.1495C35.7961 34.867 35.7753 35.9104 36.1012 36.6454C36.7378 38.0782 38.362 38.7881 39.8451 38.2576C41.4584 37.679 41.9648 35.7518 41.139 34.3387L41.1385 34.3383ZM22.173 36.9983C21.2827 37.2225 20.586 36.563 20.5335 35.7055C20.4799 34.8524 21.0672 34.6129 21.706 34.4061C22.2528 34.6511 22.8599 34.7277 23.2306 35.2954C23.7349 36.0719 22.8424 36.8299 22.173 36.9983ZM39.0769 37.0333C38.3036 37.2357 37.5336 36.668 37.3127 35.9593C37.0983 35.2735 37.4866 34.7321 37.7863 34.1633C37.9941 34.16 38.2019 34.1491 38.4141 34.183C38.9423 34.2661 39.4127 34.5265 39.7944 34.894C40.5797 35.6519 39.9814 36.7971 39.0769 37.0333V37.0333Z"
                  fill="red"
                />
              </svg>
            </span>
          </div>
          <div>
            <h6>{{ _T(CONST.ON_A_WAY) }}</h6>
            <h4 v-if="active_status > 2">
              {{
                convertDate(
                  orderStatusHistoryTime(
                    selected_order,
                    'ORDER_HISTORY_TYPE_RECORD_DELIVERY_STARTED'
                  )
                )
              }}
            </h4>
          </div>
        </li>
        <li class="col-lg-3" :class="{ active: active_status > 3 }">
          <!-- <div class="steps-line"></div> -->
          <div class="steps">
            <span>
              <svg
                width="22"
                height="26"
                viewBox="0 0 22 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.6825 15.0019C16.2007 15.3401 13.549 15.6783 12.6125 15.3919C12.2225 15.2101 11.2607 14.1437 10.7407 13.5719C10.2472 13.0255 9.77894 12.5319 9.33715 12.1155C8.58357 11.3619 7.98536 10.8419 6.89357 10.5555C5.56715 10.2173 2.24009 9.82727 1.30357 12.0373C0.315358 14.3509 0.471774 20.3838 0.523566 24.6738C0.523566 25.0374 0.757161 25.3502 1.14715 25.3502H8.24541C8.6872 25.3502 8.84362 25.1166 8.86899 24.7784C8.8954 24.5448 9.12899 20.4619 9.28541 17.5502C9.96183 18.2002 10.6372 18.7466 11.3918 18.9802C12.0936 19.2137 12.9254 19.2919 13.7836 19.2919C15.8118 19.2919 17.9436 18.8502 18.4901 18.7202C19.5037 18.4866 20.1537 17.4719 19.9201 16.4584C19.7109 15.4184 18.6973 14.7684 17.6827 15.0019L17.6825 15.0019Z"
                ></path>
                <path
                  d="M9.72679 4.96496C9.72679 7.34864 7.79405 9.28044 5.41027 9.28044C3.02649 9.28044 1.09375 7.34871 1.09375 4.96496C1.09375 2.58128 3.02649 0.648438 5.41027 0.648438C7.79405 0.648438 9.72679 2.58117 9.72679 4.96496Z"
                ></path>
                <path
                  d="M21.4002 5.69025L17.4737 7.19846C17.4473 7.19846 17.4219 7.25026 17.4219 7.27666V12.5284C17.4219 12.5802 17.4737 12.632 17.5255 12.6066L21.452 11.0984C21.4784 11.0984 21.5038 11.0466 21.5038 11.0202V5.76846C21.5302 5.71666 21.452 5.66486 21.4002 5.69025Z"
                ></path>
                <path
                  d="M16.5389 12.6066C16.5907 12.633 16.6425 12.5802 16.6425 12.5284V7.27666C16.6425 7.25026 16.6161 7.22487 16.5907 7.19846L12.6641 5.69025C12.6123 5.66486 12.5605 5.71666 12.5605 5.76846V11.0202C12.5605 11.0466 12.587 11.072 12.6123 11.0984L16.5389 12.6066Z"
                ></path>
                <path
                  d="M17.0073 6.52397H17.0591L20.5691 5.17218C20.6473 5.14577 20.6473 5.04218 20.5691 5.01577L17.0591 3.74219H17.0073L13.4708 5.01577C13.3926 5.04218 13.3926 5.14577 13.4708 5.17218L17.0073 6.52397Z"
                ></path>
              </svg>
            </span>
          </div>
          <div>
            <h6>{{ _T(CONST.FINISHED) }}</h6>
            <h4 v-if="active_status > 3">
              {{
                convertDate(
                  orderStatusHistoryTime(
                    selected_order,
                    'ORDER_HISTORY_TYPE_RECORD_DELIVERED'
                  )
                )
              }}
            </h4>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import * as CONST from '@/constants'
import { mapGetters } from 'vuex'
export default {
  name: 'OrderCarryOut',
  computed: {
    ...mapGetters([
      '_T',
      'selected_order',
      'orderStatus',
      'orderStatusHistoryTime',
    ]),
    active_status() {
      let active_status = 1
      if (this.selected_order.order_status === 'ready') active_status = 2
      if (this.selected_order.order_status === 'on-a-way') active_status = 3
      if (this.selected_order.order_status === 'finished') active_status = 4
      return active_status
    },
    order_system_status() {
      let system_status = false
      if (
        this.selected_order.order_system_status ===
          CONST.ORDER_SYSTEM_STATUS_ACCEPTANCE ||
        this.selected_order.order_system_status ===
          CONST.ORDER_SYSTEM_STATUS_REJECTED
      ) {
        system_status = true
      }
      return system_status
    },
  },
  methods: {
    // orderStatus(order_status) {
    //   if (order_status) {
    //     return order_status.replace(/-/g, ' ')
    //   }
    //   return order_status
    // },
    convertDate(datetime) {
      return datetime //? datetime.date.split('.')[0] : 0
    },
  },
}
</script>

<style lang="scss" scoped>
.status-card {
  @media (max-width: 575px) {
    border-top: $px12 solid $light-border;
    border-radius: 0;
  }
  .account-header {
    padding: $px16 $px30;
    border-bottom: 1px solid $light-border;
  }

  .status-process {
    padding: $px46 $px30;

    ul {
      li {
        text-align: center;
        .steps {
          padding: $px10 $px10 $px10 $px10;
          // width: $px220;
          // border: $px2 solid $light-border;
          border-radius: $px50;
          position: relative;
        }
        span {
          width: $px50;
          height: $px50;
          display: block;
          margin: 0 auto;
          text-align: center;
          border: $px2 solid $light-border;
          border-radius: 50%;
          padding: $px10;
          background-color: $white;
        }

        svg {
          width: $px30;
          height: $px30;
        }

        h4 {
          text-align: center;
          line-height: $px28;
          color: $light-font;
          margin-bottom: 0;
          margin-top: 0;
          font-size: $px14;
          font-weight: 600;
        }

        h6 {
          margin-bottom: 0;
          font-weight: 600;
          color: $font-color;
        }

        &.active {
          .steps {
            border-color: $primary-color;

            svg {
              path {
                fill: $primary-color;
              }
            }

            span {
              border: $px2 solid $primary-color;
            }

            h4 {
              color: $font-color;
            }

            &::before {
              border-top: $px2 solid $primary-color;
            }
          }
          &::before {
            border-color: $primary-color;
          }
        }

        &:first-child {
          &::before {
            display: none;
          }
        }

        &::before {
          position: absolute;
          content: '';
          width: 100%;
          border-top: $px2 solid $light-border;
          top: 23%;
          left: -50%;
          z-index: -1;
        }

        svg {
          path {
            fill: $light-border;
          }
        }
      }
    }
  }
}

@media (max-width: 991px) {
  .status-card {
    .status-process {
      ul {
        li {
          display: flex;
          align-items: center;
          text-align: left;
          h4 {
            margin-bottom: 0;
          }
          &::before {
            width: $px1;
            border-right: 0.125rem solid var(--color-light-border);
            border-left: none;
            top: -70%;
            left: 11.5%;
            height: 100%;
          }
          + li {
            margin-top: $px15;
          }
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .status-card {
    .status-process {
      ul {
        li {
          &::before {
            left: $px48;
          }
        }
      }
    }
  }
}
</style>
